type TodoPanelVisibilityInput = {
  canViewTasks: boolean;
  canManageTasks: boolean;
  tasksLoading: boolean;
  tasksError?: boolean;
  taskCount: number;
  totalOpenTaskCount: number;
  showChangeRequestsSection: boolean;
};

export function shouldShowTodoPanel({
  canViewTasks,
  canManageTasks,
  tasksLoading,
  tasksError = false,
  taskCount,
  totalOpenTaskCount,
  showChangeRequestsSection
}: TodoPanelVisibilityInput): boolean {
  if (showChangeRequestsSection) {
    return true;
  }

  if (!canViewTasks) {
    return false;
  }

  // View-only users keep the To Do card so they can reach EmptyState / View My Tasks.
  if (!canManageTasks) {
    return true;
  }

  // manageTasks: hide an empty inbox (QuickAdd lives above the card). Keep the card
  // during the first-load skeleton so an empty inbox does not flash before we know
  // whether there are open tasks. A failed query is not an empty inbox — keep the
  // panel so the table can show an error.
  return tasksLoading || tasksError || taskCount > 0 || totalOpenTaskCount > 0;
}
